import { useTranslation } from 'react-i18next'
import { FaLine } from 'react-icons/fa'
import { FcGoogle } from 'react-icons/fc'
import { Link } from 'react-router-dom'
import useGoogleAuthRedirect from '../../hooks/useGoogleAuthRedirect'

const CreativePark = () => {
    const { t, i18n } = useTranslation()
    useGoogleAuthRedirect()

    // Function to switch languages
    const changeLanguage = (lng) => {
        i18n.changeLanguage(lng);
    };

    return (
        <>
            <div className="battle-theme">
                <div className="section1 position-relative">
                    <div className="overlay padding text-center h-100 d-flex flex-column justify-content-center">
                        <div className="container">
                            <div className="login-box mx-auto">
                                <img src={require('../../assets/images/battle_club_logo.PNG')} alt="" 
                                    className="img-fluid mb-4" 
                                    style={{ "width": "120px" }} />
                                <h4 className='mb-3 fw-semibold'>{t('Park_Page_Heading')}</h4>

                                <div className='mt-5'>
                                    <Link to={'/park/signup'} className='btn btn1 btn-orange2 w-100'>Create an Account | 新規登録</Link>
                                </div>
                                <div className='mt-3'>
                                    <Link to={'/park/signin'} className='btn btn1 w-100'>Login | ログインはこちら</Link>
                                </div>
                                <div className='mt-3'>
                                    <Link to={`${process.env.REACT_APP_API_URL}/auth/google?type=fan`} target='_parent' className='btn btn1 btn-border w-100'><FcGoogle className='fs-2 me-1' /> <span className='align-middle'>Continue with Google</span></Link>
                                </div>
                                <div className='mt-3'>
                                    <Link to={`${process.env.REACT_APP_API_URL}/auth/line?type=fan`} target='_parent' className='btn btn1 btn-border w-100'><FaLine className='fs-2 me-1' style={{color: "#06C755"}} /> <span className='align-middle'>Continue with LINE</span></Link>
                                </div>

                            </div>

                            <div className='d-flex justify-content-center align-items-center mt-5'>
                                <Link className={`text-nowrap ${i18n.language === 'en' ? 'text-main' : ''}`} onClick={() => changeLanguage('en')}>EN</Link> 
                                <span className='mx-2'>|</span> 
                                <Link className={`me-2 text-nowrap ${i18n.language === 'ja' ? 'text-main' : ''}`} onClick={() => changeLanguage('ja')}>日本語</Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default CreativePark
